import { useState } from 'react';
import './Registrationdetails.css';
import { Link} from 'react-router-dom'; 
import api from './Login and Sign UP/api'; 
let Registrationdetails =(props)=>{
     
    let [Name, setName]= useState('');
    let [fname, setfname]= useState('');
    let [Mname, setMname]= useState('');
    let [dob, setdob]= useState('');
    let [Nationality, setnationality]= useState('');
    let [Religion, setreligion]= useState('');
    let [Marital_Status, setMarital]= useState('');
    let [Hobbies, setHobbies]= useState('');
    let [Languages, setLanguage]= useState('');
    let [choosepic, setchoosepic] = useState(''); 

    let [hnum, sethnum]=useState('');
    let [Village, setVillage]=useState('');
    let [Thana, setThana]=useState('');
    let [Post_Office, setpost]=useState('');
    let [District, setDistrict]=useState('');
    let [State, setState]=useState('');
    let [Pin_Code, setpincode]=useState('');

    let [mobnum, setmobnum] = useState('');
    let [Email_ID, setEmail] = useState('');
    let [Alternate, setAlternatenum] = useState('');
     



    
    let inputhandlechange =(e, type)=>{
        switch(type){
            case "Name":
                setName(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","Name Required");
            }
            break;
            case "Fathers_Name":
                setfname(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","Father Name Required");
            }
            break;
            case "Mothers_Name":
                setMname(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","Mother Name Required");
            }
            break;
            case "Date_Of_Birth":
                setdob(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","DOB Required");
            }
            break;
            case "Nationality":
                setnationality(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","NATIONALITY req");
            }
            break;
            case "Religion":
                setreligion(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun( "","Religion req");
            }
            break;
            case "Marital_Status":
                setMarital(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","Marital status req");
            }
            break;
            case "Hobbies":
                setHobbies(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","Hobbies status req");
            }
            break;
            case "Languages":
                setLanguage(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","Languages req");
            }
            break;

            // Address inputs 

            case "House_Number":
                sethnum(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","Hosue no req");
            }
            break;
            case "Village":
                setVillage(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","Village name req");
            }
            break;
            case "Thana":
                setThana(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","Thana req");
            }
            break;
            case "Post_Office":
                setpost(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","Post req");
            }
            break;
            case "District":
                setDistrict(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","District req");
            }
            break;
            case "State":
                setState(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","State req");
            }
            break;
            case "Pin_Code":
                setpincode(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","Pin code req");
            }
            break;


            // Contacts inputs


            case "Mobile_Number":
                setmobnum(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","Mobile no. req");
            }
            break;
            case "Email_ID":
                setEmail(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","Email idreq");
            }
            break;
            case "Alternate_Number":
                setAlternatenum(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","IF avilable");
            }
            break;

            // Image input


            case "image":
                if(e.target.files === ""){
                    setchoosepic("Image req");
                }
                if(e.target.files && e.target.files[0]){
                    let Finalimage = (URL.createObjectURL(e.target.files[0]));
                    setchoosepic(Finalimage);  
                }
            break;



            //Academic input data............
            case "Examname":
                setexam(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","IF avilable");
            }
            break;

            case "Board/uni":
                setBoard(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","IF avilable");
            }
            break;


            case "passingy":
                setpassingyear(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","IF avilable");
            }
            break;



            case "percentage":
                setpercent(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","IF avilable");
            }
            break;



            // ***********Comp input*********************
            case "Comcourse":
                setComCourse(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","IF avilable");
            }
            break;
            case "passedfrom":
                setPassedFrom(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","IF avilable");
            }
            break;
            case "compassyear":
                setComPassingYear(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","IF avilable");
            }
            break;
            case "Compercent":
                setComPercent(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","IF avilable");
            }
            break;

            // ******************Tech inputs******************************
            case "techtrade":
                settechtradename(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","IF avilable");
            }
            break;
            case "techpasyear":
                settechpassingyear(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","IF avilable");
            }
            break;
            case "techpassedfrom":
                settechfrom(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","IF avilable");
            }
            break;
            case "techpercentage":
                settechpercentage(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","IF avilable");
            }
            break;
            case "TechCoursename":
                settechcoursename(e.target.value);
                if(e.target.value === ""){
                props.Successandrerrorfun("","IF avilable");
            }
            break;

            

        }
    };
//***************Academic inputs data************************* */
let [exam, setexam] = useState('');
let [Board, setBoard] = useState(''); 
let [passingyear, setpassingyear] = useState('');   
let [percent, setpercent] = useState('');


    let [fdata, setfdata]= useState(['']);
    
    let funfun =(gotacadata)=>{
        let acadata = [gotacadata, ...fdata];
        setfdata(acadata);
    }
    
    let examonclickhandler = async(e)=>{
        e.preventDefault();
        
        let ddata = {
            ExamName : exam,
            BoardName : Board,
            PassingYear : passingyear,
            PercentAge : percent  
        }

        funfun(ddata);
        props.GetAcademicData(ddata);

        

        let academicformdata = new FormData();
        academicformdata.append('userid', props.Apiregdata.id)
        academicformdata.append('stream', exam)
        academicformdata.append('boardUniverciy', Board)
        academicformdata.append('passingyear', passingyear)
        academicformdata.append('percentage', percent)

        try {
            const response = await api.post('/academicdata.php', academicformdata)
            props.Successandrerrorfun(response.data.result, "");
            props.checkemptyfun();
        } catch (error) {
            console.log(error.message);
            
        }
        

       
         
      document.querySelector(".acamsg").innerHTML ="Data Added! You can add multiple data"
      setTimeout(() => {
        document.querySelector(".acamsg").innerHTML ="";
      }, 5000);
        
        setpercent('');
        setpassingyear('');
        setBoard('');
        setexam('');
    }

// **********************Computers inputs data***********************************
let [ComCourse, setComCourse]= useState('');
let [PassedFrom, setPassedFrom]= useState('');
let [ComPassingYear, setComPassingYear]= useState('');
let [ComPercent, setComPercent]= useState('');


let [Finalcomdata, setFinalcomdata] = useState([""]);
let comfunfun = (comdatareceved)=>{
    let finalcomdata = [comdatareceved, ...Finalcomdata];
    setFinalcomdata(finalcomdata)
}



let comclickhandler =async(e)=>{
    e.preventDefault();
    let comdata = {
        CourseName : ComCourse,
        Frompass : PassedFrom,
        Compassingy : ComPassingYear,
        compercent : ComPercent
    }
    comfunfun(comdata);
    props.GetComputerData(comdata);


      
    let computerformdata = new FormData();
    computerformdata.append('userid', props.Apiregdata.id);
    computerformdata.append('ExamName', ComCourse)
    computerformdata.append('from', PassedFrom)
    computerformdata.append('PassingYear', ComPassingYear)
    computerformdata.append('PercentAge', ComPercent)

    try {
        const response = await api.post('/computerdata.php', computerformdata)
        props.Successandrerrorfun(response.data.result, "");
    } catch (error) {
        console.log(error.message)
        
    }

    document.querySelector(".commsg").innerHTML ="Data Added! You can add multiple data"
      setTimeout(() => {
        document.querySelector(".commsg").innerHTML =""
      }, 2000);

    setComCourse('');
    setPassedFrom('');
    setComPassingYear('');
    setComPercent('');
    
}

// ============Technical inputs data ================sarted======================
let [TechCourseName, settechcoursename] = useState('');
let [techtradename, settechtradename] = useState('');
let [techpassingyear, settechpassingyear] = useState('');
let [techpercentage, settechpercentage] = useState('');
let [techfrom, settechfrom] = useState('');


let [FinalTechData, setFinalTechData] = useState(['']);
let Techfunfun=(receivedtechdata)=>{
    let finaltechdata = [receivedtechdata, ...FinalTechData];
    setFinalTechData(finaltechdata);
}

let techbtnclickhandler=async(e)=>{
    e.preventDefault();
    let techdata = {
        TechCourseName : TechCourseName,
        TechTradeName : techtradename,
        TechPassingYear : techpassingyear,
        TechPercentage : techpercentage,
        Techfromwhere : techfrom
    }
    props.GetTechnicalData(techdata);

     

    let technicalformdata = new FormData();
    technicalformdata.append('userid', props.Apiregdata.id);
    technicalformdata.append('ExamName', TechCourseName)
    technicalformdata.append('FromWhere', techfrom)
    technicalformdata.append('Percentage', techpercentage)
    technicalformdata.append('PassingYear', techpassingyear)
    technicalformdata.append('TradeName', techtradename)
    try {
        const response = await api.post('/technicaldata.php', technicalformdata)
        props.Successandrerrorfun(response.data.result, "");
    } catch (error) {
        console.log(error.message)
        
    }

    document.querySelector(".tecmsg").innerHTML ="Data Added! You can add multiple data"
      setTimeout(() => {
        document.querySelector(".tecmsg").innerHTML =""
      }, 2000);
    Techfunfun(techdata);
    settechpercentage('');
    settechpassingyear('');
    settechtradename('');
    settechcoursename('');
    settechfrom('');

}; 

// =================Experiance section started========================

let [WorkedYear, setWorkedYear] = useState('');
let [WorkingAs, setWorkingAs] = useState('');
let [CompNameAndAddress, setCompNameAndAddress] = useState('');
let [Period, setperiod] = useState('');



let Workedyearchangehandler =(e)=>{
    setWorkedYear(e.target.value);
}
let Workingaschangehandler =(e)=>{
    setWorkingAs(e.target.value);
}
let Compnameaddrchangehandler =(e)=>{
    setCompNameAndAddress(e.target.value);
}
let Periodchangehandler =(e)=>{
    setperiod(e.target.value);
}


let [Finalexperiancedata, setfinalexpdata] = useState(['']);
let Experiancefunfun =(ReceivedExperianceData)=>{
    let finaexpdata = [ReceivedExperianceData, ...Finalexperiancedata];
    setfinalexpdata(finaexpdata);
}
let Experiancebtnclickhandler=async(e)=>{
    e.preventDefault();
    let Experiancedata = {
        ExperianceYear : WorkedYear,
        CompanyName : WorkingAs,
        CompanyAddress : CompNameAndAddress,
        FromDateToDate : Period,
        Year : 'Years Worked As',
        At : 'At',
        From : 'From'
    }
    props.GetExpData(Experiancedata);
    Experiancefunfun(Experiancedata);


    

    let wordedformdata = new FormData();
    wordedformdata.append('userid', props.Apiregdata.id);
    wordedformdata.append('WorkedYears', WorkedYear)
    wordedformdata.append('WorkingAs', WorkingAs)
    wordedformdata.append('CompanyNameAndAddress', CompNameAndAddress)
    wordedformdata.append('WorkedPeriod', Period)
    try {
        const response = await api.post('/workexp.php', wordedformdata)
        props.Successandrerrorfun(response.data.result, "");
    } catch (error) {
        console.log(error.message);
        
    }

    document.querySelector(".expmsg").innerHTML ="Data Added! You can add multiple data"
      setTimeout(() => {
        document.querySelector(".expmsg").innerHTML =""
      }, 2000);
    setperiod('');
    setCompNameAndAddress('');
    setWorkingAs('');
    setWorkedYear('');

}
   



// Passport functions starts
let [passportExpiry, setpassportexpiry]=useState('');
let [passportIssuingdate, setpassportissuingdate]=useState('');
let [aadharnum, setaadharnum]=useState('');
let [passportNumber, setpassportnumber]=useState('');
let [passportdistrict, setpassportdistrict]=useState('');


let Expirydatechanghandler=(e)=>{
    setpassportexpiry(e.target.value);
}
let Issuingdatechangehandler=(e)=>{
    setpassportissuingdate(e.target.value);
}

let passportNamechangehandler=(e)=>{
    setaadharnum(e.target.value);
}
let passportnumberchangehandler=(e)=>{
    setpassportnumber(e.target.value);
}
let Districtchanghandler=(e)=>{
    setpassportdistrict(e.target.value);

}
let [maainfinaldatapassport, setfinaldatapassport]=useState('');
let passportbtnclicked=async()=>{
    let passportdata = {
        AadhaarNum : aadharnum,  
        passportissuingdate : passportIssuingdate,
        passportexpirydate : passportExpiry,
        paassportnumber :passportNumber,
        passportdistrict : passportdistrict
    };
    setfinaldatapassport(passportdata);
    props.Getpasspoetdata(passportdata);
     
    let passportformdata = new FormData();
    passportformdata.append('userid', props.Apiregdata.id)
    passportformdata.append('passportnumber', passportNumber)
    passportformdata.append('issuingDate', passportIssuingdate)
    passportformdata.append('expiryDate', passportExpiry)
    passportformdata.append('district', passportdistrict)
        
    try {
        const response = await api.post('/userspassport.php', passportformdata)
        props.Successandrerrorfun(response.data.result, "");
    } catch (error) {
        console.log(error.message)
        
    }

    document.querySelector(".passmsg").innerHTML ="Data Added! You can add multiple data"
      setTimeout(() => {
        document.querySelector(".passmsg").innerHTML =""
      }, 2000);

    setpassportnumber('');
    setaadharnum('');
    setpassportexpiry('');
    setpassportissuingdate('');
    setpassportdistrict('');
}

// Physical functining starting-----------------
let [Height, setHeight]=useState('');
let [Weight, setweight]=useState('');
let [BloodGroup, setBloodGroup]=useState('');
let [PwPDisability, setPwPDisability]=useState('');

let pwpdisabilityfun=(e)=>{
    setPwPDisability(e.target.value);
}
let BloodGroupfun=(e)=>{
    setBloodGroup(e.target.value);
}
let Weightchangefun=(e)=>{
    setweight(e.target.value);
}
 let heightchangefun=(e)=>{
    setHeight(e.target.value);
}



let [preview, setpreview]=useState(['']);
let physicalbtnclicked=async()=>{
    let Physicaldata={
        Height : Height,
        weight: Weight,
        BloodGroup : BloodGroup,
        Pwpdisability : PwPDisability
    }
    setpreview(Physicaldata);
    props.Getphydata(Physicaldata);



    let physicalformdata = new FormData();
    physicalformdata.append('userid', props.Apiregdata.id)
    physicalformdata.append('height', Height)
    physicalformdata.append('weight', Weight)
    physicalformdata.append('bloodgroup', BloodGroup)
    physicalformdata.append('PwpDisability', PwPDisability)


    try {
        const response = await api.post('/usersphysical.php', physicalformdata);
         props.Successandrerrorfun(response.data.result, "");
    } catch (error) {
        console.log(error.message)
        
    }


    document.querySelector(".phymsg").innerHTML ="Data Added! You can add multiple data"
      setTimeout(() => {
        document.querySelector(".phymsg").innerHTML =""
      }, 2000);
    setPwPDisability('');
    setBloodGroup('');
    setweight('');
    setHeight('');

}

    
    

    let [Addressdata, setAddressdata] = useState('');
    let [personaldata, setpersonaldata] = useState('');
    let [Contactdata, setContactdata] = useState('');
    
    
    let submithandler = (e)=>{
        e.preventDefault();
        if(Name === ""){
            alert("name is empty")
            return null;
        }else if(fname === ""){
            props.Successandrerrorfun("","Father name is empty")
            return null;
        }else if(Mname === ""){
            props.Successandrerrorfun("","Mother name is empty")
            return null;
        }else if(dob === ""){
            props.Successandrerrorfun("","Date of Birth is empty")
            return null;
        }else if(Nationality === ""){
            props.Successandrerrorfun("","Nationality is empty")
            return null;
        }else if(Religion === ""){
            props.Successandrerrorfun("","Religion is empty")
            return null;
        }else if(Marital_Status === ""){
            props.Successandrerrorfun("","Marital_Status is empty")
            return null;
        }else if(Hobbies === ""){
            props.Successandrerrorfun("","Hobbies is empty")
            return null;
        }else if(Languages === ""){
            props.Successandrerrorfun("","Languages is empty")
            return null;
        }else if(hnum === ""){
            props.Successandrerrorfun("","hnum is empty")
            return null;
        }else if(Village === ""){
            props.Successandrerrorfun("","Village is empty")
            return null;
        }else if(Thana === ""){
            props.Successandrerrorfun("","Thana is empty")
            return null;
        }else if(Post_Office === ""){
            props.Successandrerrorfun("","Post_Office is empty")
            return null;
        }else if(District === ""){
            props.Successandrerrorfun("","District is empty")
            return null;
        }else if(State === ""){
            props.Successandrerrorfun("","State is empty")
            return null;
        }else if(Pin_Code === ""){
            props.Successandrerrorfun("","Pin_Code is empty")
            return null;
        }else if(mobnum === ""){
            props.Successandrerrorfun("","Mobile Number is empty")
            return null;
        }else if(Alternate === ""){
            props.Successandrerrorfun("","Alternate is empty")
            return null;
        }
        
        
        let DATA = {
            Name : Name,
            fname : fname,
            Mname :Mname,
            dob : dob,
            Nationality : Nationality,
            Religion : Religion,
            Marital_Status : Marital_Status,
            Hobbies : Hobbies,
            Languages : Languages,

        }
        setpersonaldata(DATA);
        let address={
            hnum : hnum,
            Village : Village,
            Thana : Thana,
            Post_Office : Post_Office,     
            District : District,
            State : State,
            Pin_Code : Pin_Code,
        };
        setAddressdata(address);
        let contactdata={
            mobnum : mobnum,
            Email_ID :  Email_ID,
            Alternate : Alternate
        }
        setContactdata(contactdata)
        document.querySelector('.main_conttt').style.display = "none";
        document.querySelector('.table_cont').style.display = "block";

        
        if(fdata == ''){
            document.querySelector('.academic_table').style.display = "none";
            
        }else{
            // fdata.pop();
        }
        if(Finalcomdata == ""){
            document.querySelector('.comtable').style.display = "none";  

        }else{
            // Finalcomdata.pop();
        }
        if(FinalTechData == ""){
            document.querySelector('.tech_table').style.display = "none";

        }else{
            // FinalTechData.pop();
            
        }
        if(Finalexperiancedata == ""){
            document.querySelector('.exptab').style.display = "none";

        }else{
            // Finalexperiancedata.pop();
        }
        if(maainfinaldatapassport == ""){
            document.querySelector('.passport_table').style.display = "none";

        }else{
            // Finalexperiancedata.pop();
        }
        if(preview == ""){
            document.querySelector('.Physical_table').style.display = "none";

        }else{ 
            // Finalexperiancedata.pop();
        }

        
    }    
    let [checkbox, setcheckbox]=useState('');
    let carriercheckbox=(e)=>{
        if(e.target.checked === true){
            setcheckbox("To seek a good & responsible job in professionally managed organization where in my conceptual and functional skills are effectively utilized in a way that contributes to the organization growth coupled with personal growth within the organization");
        }
    }



    // ---------------------FETCH API SECTION-------------------------

    // -----------------------PERSONAL SECTION---------------------------
    
    const alldataapifunction = async()=>{
         if(props.contactdata.userid === props.Apiregdata.id){
            props.Successandrerrorfun("", "contact already exist");
            return;
         }
        let contatformdata = new FormData();
        contatformdata.append('userid', props.Apiregdata.id)
        contatformdata.append('mobilenum', Contactdata.mobnum)
        contatformdata.append('email', Contactdata.Email_ID)
        contatformdata.append('alternatenum', Contactdata.Alternate)
       
        try {
            const response = await api.post('/userscontact.php', contatformdata);
             props.Successandrerrorfun(response.data.result, "");
        } catch (error) {
            console.log(error.message)
        }
 
        if(props.Addrdata.userid === props.Apiregdata.id){
            props.Successandrerrorfun("", "Address already exist");
            return;   
        }
        let formdata = new FormData();
            formdata.append('houseno' , Addressdata.hnum);
            formdata.append('village' , Addressdata.Village);
            formdata.append('post' , Addressdata.Post_Office);
            formdata.append('thana' , Addressdata.Thana);
            formdata.append('district' , Addressdata.District);
            formdata.append('state' , Addressdata.State);
            formdata.append('pincode' , Addressdata.Pin_Code);
            formdata.append('userid' , props.Apiregdata.id);

        try {
            const response = await api.post('/usersaddress.php', formdata);
            props.Successandrerrorfun(response.data.result, "");
        } catch (error) {
            console.log(error.message)
            
        }




        
    }



    let submitbtnhandler = (e)=>{
        let Formdata = {
            Name : personaldata.Name,
            fname : personaldata.fname,
            Mname :personaldata.Mname,
            dob : personaldata.dob,
            Nationality : personaldata.Nationality,
            Religion : personaldata.Religion,
            Marital_Status : personaldata.Marital_Status,
            Hobbies : personaldata.Hobbies,
            Languages : personaldata.Languages,


            hnum : Addressdata.hnum,
            Village : Addressdata.Village,
            Thana : Addressdata.Thana,
            Post_Office : Addressdata.Post_Office,     
            District : Addressdata.District,
            State : Addressdata.State,
            Pin_Code : Addressdata.Pin_Code,
            mobnum : Contactdata.mobnum,
            Email_ID :  Contactdata.Email_ID, 
            Alternate : Contactdata.Alternate,
            Imagge : !choosepic ? `https://makeeasyway.in/resumeData/`+props.Apiregdata.avatar : choosepic,
            cardata : checkbox,
           
        }
        props.getdatafromgetter(Formdata);
        alldataapifunction();
        
        
         
    }

    let chooseclickhandler=()=>{
      let checkboxes = document.querySelectorAll(".inputs_checkboxes");
      for(let x of checkboxes){
        if(x.checked){
            if(x.id === "aca"){
            document.querySelector(".Academic_quli").style.display = "block";
            }else if(x.id === "comp"){
                document.querySelector(".computer_qli").style.display = "block";

            }else if(x.id === "tech"){
                document.querySelector(".technical_qli").style.display = "block";
            }else if(x.id === "exp"){
                document.querySelector(".experiance_qli").style.display = "block";
            }else if(x.id === "pass"){
                document.querySelector(".Passport_det").style.display = "block";
            }
            else if(x.id === "phy"){
                document.querySelector(".Physical_det").style.display = "block";
            }
        }
      }
      document.querySelector(".choose_qli_cont").style.display = "none";
      document.querySelector(".main_conttt").style.display = "block";


      setName(props.Apiregdata.fullName);
      setMname(props.Apiregdata.mothername);
      setfname(props.Apiregdata.fathername);
      setdob(props.Apiregdata.dob);
      setAlternatenum(props.contactdata.alternatenum);
      setEmail(props.Apiregdata.email)
      setmobnum(props.contactdata.mobilenum);
      sethnum(props.Addrdata.houseno)
      setVillage(props.Addrdata.village)
      setpost(props.Addrdata.post)
      setThana(props.Addrdata.thana)
      setDistrict(props.Addrdata.district)
      setState(props.Addrdata.state)
      setpincode(props.Addrdata.pincode)
        
    }


    let Updatehandler=()=>{
        let editeddatapersonal={
            Name : Name,
            fname : fname,
            Mname :Mname,
            dob : dob,
            Nationality : Nationality,
            Religion : Religion,
            Marital_Status : Marital_Status,
            Hobbies : Hobbies,
            Languages : Languages
        };
        setpersonaldata(editeddatapersonal);
        let address={
            hnum : hnum,
            Village : Village,
            Thana : Thana,
            Post_Office : Post_Office,     
            District : District,
            State : State,
            Pin_Code : Pin_Code
        };
        setAddressdata(address);
        let contactdata={
            mobnum : mobnum,
            Email_ID :  Email_ID,
            Alternate : Alternate
        }
        setContactdata(contactdata);
        document.querySelector(".editformpersonal").style.display = "none";
        document.querySelector(".editformaddress").style.display = "none";
        document.querySelector(".editformcontact").style.display = "none";
        


    }
    let personaldataedit=(Tobeedit)=>{
        document.querySelector(".editformpersonal").style.display = "block";
        setLanguage(Tobeedit.Languages)
        setHobbies(Tobeedit.Hobbies)
        setMarital(Tobeedit.Marital_Status)
        setreligion(Tobeedit.Religion)
        setnationality(Tobeedit.Nationality)
        setdob(Tobeedit.dob)
        setMname(Tobeedit.Mname)
        setfname(Tobeedit.fname)
        setName(Tobeedit.Name)
    }

    let Addressdataedit=(Tobeedit)=>{
        document.querySelector(".editformaddress").style.display = "block";
        sethnum (Tobeedit.hnum);
        setVillage(Tobeedit.Village);
        setThana(Tobeedit.Thana);
        setpost(Tobeedit.Post_Office); 
        setDistrict(Tobeedit.District); 
        setState(Tobeedit.State); 
        setpincode(Tobeedit.Pin_Code); 
       
    }

    let contactdataedit=(Tobeedit)=>{
        document.querySelector(".editformcontact").style.display = "block";
        setAlternatenum(Tobeedit.Alternate);
        setEmail(Tobeedit.Email_ID);
        setmobnum(Tobeedit.mobnum);
    }

    let canceledit=()=>{
        document.querySelector(".editformpersonal").style.display = "none";
        document.querySelector(".editformaddress").style.display = "none";
        document.querySelector(".editformcontact").style.display = "none";
    }


    return(
        <div className='regdelmaindiv'>
            <div className='choose_qli_cont'>
                <h2 className='choose_heading'>Choose Your Qualification</h2>
                <div className='choose_items_cont_main'>
                    <div className='ist_choose_itmes both_same'>
                        <div>
                            <input id='aca' className='inputs_checkboxes' type='checkbox'/>
                            <label htmlFor='aca'>Academic Qualification</label>
                        </div>
                        <div>
                            <input id='comp' className='inputs_checkboxes' type='checkbox'/>
                            <label htmlFor='comp'>Computer Qualification</label>
                        </div>
                    </div>

                    <div className='second_choose_itmes both_same'>
                        <div>
                            <input id='tech' className='inputs_checkboxes' type='checkbox'/>
                            <label htmlFor='tech'>Technical Qualification</label>
                        </div>
                        <div>
                            <input id='exp' className='inputs_checkboxes' type='checkbox'/>
                            <label htmlFor='exp'>Experience Qualification</label>
                        </div> 
                       
                    </div>


                    <div className='ist_choose_itmes both_same'>
                        <div>
                            <input id='pass' className='inputs_checkboxes' type='checkbox'/>
                            <label htmlFor='pass'>Passposrt Details</label>
                        </div>
                        <div>
                            <input id='phy' className='inputs_checkboxes' type='checkbox'/>
                            <label htmlFor='phy'>Physical Details</label>
                        </div>
                    </div>
                </div>
                <div className='submit_btn_cont'>
                    <button className='choose_btn' onClick={chooseclickhandler}>Submit</button>
                </div>
            </div>

            <form className='main_conttt'>
                <div className='personal_details_cont'>
                <h2 className='per_headingg'>Fill Form Very Carefully</h2> 
                        <h2 className='per_heading'>Personal Details</h2>
                        <div className='persnl_det_box'>
                            <input type='text' value={Name}  className='perinputs' name='Name' onChange={(e)=>{inputhandlechange(e, "Name")}} placeholder='Enter Name'/>

                            <input type='text' className='perinputs' value={fname} name='Fathers_Name'  onChange={(e)=>{inputhandlechange(e, "Fathers_Name")}} placeholder='Fathers Name'/>

                            <input type='text' className='perinputs'  value={Mname} name='Mothers_Name'  onChange={(e)=>{inputhandlechange(e, "Mothers_Name")}} placeholder='Mothers Name'/>

                            <input type='date' className='perinputs'  value={dob} name='Date_Of_Birth'  onChange={(e)=>{inputhandlechange(e, "Date_Of_Birth")}} placeholder='Date of Birth'/>

                            <input type='text' className='perinputs'  value={Nationality} name='Nationality'  onChange={(e)=>{inputhandlechange(e, "Nationality")}} placeholder='Nationality'/>

                            <input type='text' value={Religion} className='perinputs'   name='Religion'  onChange={(e)=>{inputhandlechange(e, "Religion")}} placeholder='Religion'/>     

                            <input type='text' value={Marital_Status} className='perinputs'   name='Marital_Status'  onChange={(e)=>{inputhandlechange(e, "Marital_Status")}} placeholder='Marital Status'/>

                            <input type='text' value={Hobbies}  name='Hobbies' className='perinputs'   onChange={(e)=>{inputhandlechange(e, "Hobbies")}} placeholder='Hobby'/>

                            <input type='text' value={Languages} className='perinputs'   name='Languages'  onChange={(e)=>{inputhandlechange(e, "Languages")}} placeholder='Language'/>

                            <label style={{backgroundColor:"blue",margin:"0px 10px", padding:"10px 20px" , color:"white"}} htmlFor='perinputfile'>Upload Image</label>
                            <input name='image' style={{display:"none"}}  id='perinputfile'  className='perinputs'  onChange={(e)=>{inputhandlechange(e, "image")}}  type='file'/>
                            <div  style={{margin: "10px"}}>
                                <input onClick={carriercheckbox}  style={{width:"18px", height:"18px"}} type='checkbox' id='perchekbox'/>
                                <label htmlFor='perchekbox'>Check the box to add Carrier Objective in Your Resume</label>
                            </div>
                            
                        </div>
                </div>
                <div className='personal_details_cont'>
                        <h2 className='per_heading'>Address Details</h2>
                        <div className='persnl_det_box'>
                            <input type='text' value={hnum}  className='perinputs'  name='House_Number' onChange={(e)=>{inputhandlechange(e, "House_Number")}} placeholder='House No'/>


                            <input type='text' value={Village}  className='perinputs'  name='Village' onChange={(e)=>{inputhandlechange(e, "Village")}} placeholder='Village'/>

                            <input type='text' value={Thana}  className='perinputs'  name='Thana' onChange={(e)=>{inputhandlechange(e, "Thana")}} placeholder='Thana'/>

                            <input type='text'  className='perinputs'  value={Post_Office} name='Post_Office' onChange={(e)=>{inputhandlechange(e, "Post_Office")}} placeholder='Post Office'/>

                            <input type='text'  className='perinputs'  value={District} name='District' onChange={(e)=>{inputhandlechange(e, "District")}}placeholder='District'/>

                            <input type='text'  className='perinputs'  value={State} name='State' onChange={(e)=>{inputhandlechange(e, "State")}} placeholder='State'/>   

                            <input type='text'  className='perinputs'  value={Pin_Code} name='Pin_Code' onChange={(e)=>{inputhandlechange(e, "Pin_Code")}} placeholder='Pin Code'/>
                        </div>
                </div>
                <div className='personal_details_cont'>
                        <h2 className='per_heading'>Contact Details</h2>
                        <div className='persnl_det_box'>

                            <input type='text'  className='perinputs'  value={mobnum} name='Mobile_Number' onChange={(e)=>{inputhandlechange(e, "Mobile_Number")}} placeholder='Mobile Number'/>

                            <input type='text'  className='perinputs'  value={Email_ID} name='Email_ID' onChange={(e)=>{inputhandlechange(e, "Email_ID")}} placeholder='Email ID'/>

                            <input type='text'  className='perinputs'  value={Alternate} name='Alternate_Number' onChange={(e)=>{inputhandlechange(e, "Alternate_Number")}} placeholder='Alternate Number'/>
                        </div>
                </div>



                <div className='Academic_quli academic_qli'>
                    <div className='comp_cont'>
                        <h2 className='Academic_heading'>Academic Qualification</h2>
                        <div>
                            <input type='text' name='Examname' value={exam} onChange={(e)=>{inputhandlechange(e, "Examname")}} placeholder='Exam Name'/>

                            <input type='text' value={Board} name='Board/uni'  onChange={(e)=>{inputhandlechange(e, "Board/uni")}} placeholder='Board/Univercity Name'/>

                            <input type='text' name='passingy' value={passingyear}  onChange={(e)=>{inputhandlechange(e, "passingy")}}placeholder='Passing Year'/>

                            <input type='text' name='percentage' value={percent}  onChange={(e)=>{inputhandlechange(e, "percentage")}} placeholder='%Age'/>


                            <input className='save_btn' onClick={examonclickhandler} type='submit' value='SAVE'/>
                        </div>  
                        <div>
                            <span className='acamsg'></span>
                        </div>
                    </div>  
                </div> 

                <div className='academic_qli computer_qli'>
                    <div className='comp_cont'>
                        <h2 className='Academic_heading'>Computer Qualification</h2>
                        <div>
                            <input type='text' name='Comcourse' value={ComCourse} onChange={(e)=>{inputhandlechange(e, "Comcourse")}} placeholder='Comcourse'/>

                            <input type='text' name='passedfrom' value={PassedFrom} onChange={(e)=>{inputhandlechange(e, "passedfrom")}}  placeholder='From'/>

                            <input type='text' name='compassyear' value={ComPassingYear} onChange={(e)=>{inputhandlechange(e, "compassyear")}}  placeholder='Passing Year'/>

                            <input type='text' name='Compercent' value={ComPercent} onChange={(e)=>{inputhandlechange(e, "Compercent")}}  placeholder='%Age'/>

                            <input className='save_btn' onClick={comclickhandler} type='submit' value='SAVE'/>
                        </div>
                        <div>
                            <span className='commsg'></span>
                        </div>
                    </div>
                </div>
                <div className='academic_qli technical_qli'>
                    <div className='comp_cont'>
                        <h2 className='Academic_heading'>Technical Qualification</h2>
                        <div>
                            <input type='text' name='TechCoursename' value={TechCourseName} onChange={(e)=>{inputhandlechange(e, "TechCoursename")}} placeholder='Course Name'/>

                            <input type='text' name='techtrade' value={techtradename} onChange={(e)=>{inputhandlechange(e, "techtrade")}}  placeholder='Trade Name'/>

                            <input type='text' name='techpasyear' value={techpassingyear} onChange={(e)=>{inputhandlechange(e, "techpasyear")}}  placeholder='Passing Year'/>

                            <input type='text' name='techpassedfrom' value={techfrom} onChange={(e)=>{inputhandlechange(e, "techpassedfrom")}} placeholder='Tech From Where'/>

                            <input type='text' name='techpercentage' value={techpercentage} onChange={(e)=>{inputhandlechange(e, "techpercentage")}}  placeholder='%Age'/>
                            <div>
                            <input style={{marginLeft:"0px"}} className='save_btn' onClick={techbtnclickhandler} type='submit' value='SAVE'/>
                            </div>
                            <div>
                            <span className='tecmsg'></span>
                        </div>

                            
                        </div>
                    </div>
                </div>
                <div className='Passport_det'>
                    <div className='headmaincont_passport'>
                        <h3 className='passportheading'>Passport Details</h3>
                    </div>
                    <div className='passport_inputs'>
                        <input type='text' value={aadharnum} onChange={passportNamechangehandler} placeholder='Enter Aadhaar Number'/>
                        <input type='text' value={passportNumber} onChange={passportnumberchangehandler} placeholder='Enter Passport Number'/>
                        <input type='text' value={passportIssuingdate} onChange={Issuingdatechangehandler} placeholder='Issuing Date'/>
                        <input type='text' value={passportExpiry} onChange={Expirydatechanghandler} placeholder='Expiry Date'/>
                        <input type='text' value={passportdistrict} onChange={Districtchanghandler} placeholder='Issu From'/>
                        <input type='button' className='passport_save_btn' onClick={passportbtnclicked} value="Save"/>
                    </div>
                    <div>
                        <span className='passmsg'></span>
                    </div>

                </div> 
                <div className='Passport_det Physical_det'>
                    <div className='headmaincont_passport headmaincont_physical'>
                        <h3 className='passportheading physicalheading'>Physical Details</h3>
                    </div>
                    <div className='passport_inputs physical_inputs'>
                        <input type='text' value={Height} onChange={heightchangefun} placeholder='Height'/>
                        <input type='text' value={Weight} onChange={Weightchangefun} placeholder='Weight'/>
                        <input type='text' value={BloodGroup} onChange={BloodGroupfun} placeholder='Blood Group'/>
                        <input type='text' value={PwPDisability} onChange={pwpdisabilityfun} placeholder='PwP Disability'/>
                        <input type='button' className='phydavebtn' onClick={physicalbtnclicked} value="Save"/>
                    </div>
                    <div>
                        <span className='phymsg'></span>
                    </div>

                </div>
                <div className='academic_qli experiance_qli '>
                    <div className='comp_cont'>
                        <h2 className='Academic_heading'>Experience</h2>
                        <div>
                            <input type='text' value={WorkedYear} onChange={Workedyearchangehandler} placeholder='Experianced Year'/>
                            <input type='text' value={WorkingAs}  onChange={Workingaschangehandler} placeholder='Working As'/>
                            <input type='text' value={CompNameAndAddress}  onChange={Compnameaddrchangehandler} placeholder='Company Name & Address'/>
                            <input type='text' value={Period}  onChange={Periodchangehandler} placeholder='Period'/>
                            <input className='save_btn' onClick={Experiancebtnclickhandler} type='submit' value='SAVE'/>
                        </div>
                        <div>
                            <span className='expmsg'></span>
                        </div>
                    </div>
                </div>
                <div className='btn_cont'>
                        <button className='main_submit_btn' onClick={submithandler}>Submit</button>
                </div>
            </form>


{/*----------------------Check Details section started------------------------ */}
                <div className='table_cont'>  
                    {/* ----------------Editsection start--------------- */}
                    <div className='editformpersonal  editstylingsame'> 
                        <div>
                            <p style={{margin:"0", fontSize:"20px"}}>Edit Personal Details</p>
                            {/* <label htmlFor='name'>Name</label> */}
                            <input id='name' value={Name} onChange={(e)=>setName(e.target.value)}  type='text' placeholder='name'/>

                            {/* <label htmlFor='fname'>fathername</label> */}
                            <input id='fname' value={fname} onChange={(e)=>setfname(e.target.value)} type='text' placeholder='fathername'/>

                            {/* <label htmlFor='mname'>Mother Name</label> */}
                            <input id='mname' value={Mname} onChange={(e)=>setMname(e.target.value)} type='text' placeholder='mothername'/>

                            {/* <label htmlFor='dob'>Date Of Birth</label> */}
                            <input id='dob' value={dob} onChange={(e)=>setdob(e.target.value)} type='date' placeholder='dob'/>

                            {/* <label htmlFor='nat'>Nationality</label> */}
                            <input id='nat' value={Nationality} onChange={(e)=>setnationality(e.target.value)} type='text' placeholder='nationality'/>

                            {/* <label htmlFor='reg'>Religion</label> */}
                            <input id='reg' value={Religion} onChange={(e)=>setreligion(e.target.value)} type='text' placeholder='religion'/>

                            {/* <label htmlFor='marit'>Marital</label> */}
                            <input id='marit' value={Marital_Status} onChange={(e)=>setMarital(e.target.value)} type='text' placeholder='marital'/> 

                            {/* <label htmlFor='hobi'>Hobbies</label> */}
                            <inpu id='hobi' value={Hobbies} onChange={(e)=>setHobbies(e.target.value)} type='text' placeholder='Hobbies'/>
                        </div>
                        <div>
                            <button className='updatebtn' onClick={Updatehandler}>Update</button>
                            <button className='updatebtn' onClick={canceledit}>Cancel</button>
                        </div>
                        
                        
                    </div>
                    <div className='editformaddress editstylingsame'>
                        <div>
                        <p style={{margin:"0", fontSize:"20px"}}>Edit Address Details</p>
                            <input type='text' placeholder='Housenum' onChange={(e)=>sethnum(e.target.value)} value={hnum}/>

                            <input type='text' placeholder='Village' onChange={(e)=>setVillage(e.target.value)} value={Village}/>

                            <input type='text' placeholder='Thana' onChange={(e)=>setThana(e.target.value)} value={Thana}/>

                            <input type='text' placeholder='Post Office' onChange={(e)=>setpost(e.target.value)} value={Post_Office}/>

                            <input type='text' placeholder='Dustrict' onChange={(e)=>setDistrict(e.target.value)} value={District}/>

                            <input type='text' placeholder='State' onChange={(e)=>setState(e.target.value)} value={State}/>

                            <input type='text' placeholder='Pin code' onChange={(e)=>setpincode(e.target.value)} value={Pin_Code}/>
                        </div>
                        <div>
                            <button className='updatebtn' onClick={Updatehandler}>Update</button>
                            <button className='updatebtn' onClick={canceledit}>Cancel</button>
                        </div>
                    </div>
                    <div className='editformcontact editstylingsame'>
                        <div>
                        <p style={{margin:"0", fontSize:"20px"}}>Edit Contace Details</p>
                            <input type='text' placeholder='Mobile Number' value={mobnum} onChange={(e)=>setmobnum(e.target.value)}/>
                            <input type='text' placeholder='Email' value={Email_ID} onChange={(e)=>setEmail(e.target.value)}/>
                            <input type='text' placeholder='Altername number' value={Alternate} onChange={(e)=>setAlternatenum(e.target.value)}/>
                        </div>
                        <div>
                            <button className='updatebtn' onClick={Updatehandler}>Update</button>
                            <button className='updatebtn' onClick={canceledit}>Cancel</button>
                        </div>
                            
                </div>

                {/*-------------------First Table started---------------  */}
                <table className='maintable'>
                    <caption className='checkdetails'>Check Details Carefully</caption>
                    <caption>Personal Details</caption>
                    <tbody>
                        <tr>
                            <td>NAME</td>
                            <td>{personaldata.Name}</td>
                        </tr>
                        <tr>
                            <td>Father's Name</td>
                            <td>{personaldata.fname}</td>
                        </tr>
                        <tr>
                            <td>Mother's Name</td>
                            <td>{personaldata.Mname}</td>
                        </tr>
                        <tr>
                            <td>Date Of Birth</td>
                            <td>{personaldata.dob}</td>
                        </tr>
                        <tr>
                            <td>Nationality</td>
                            <td>{personaldata.Nationality}</td>
                        </tr>
                        <tr>
                            <td>Religion</td> 
                            <td>{personaldata.Religion}</td>
                        </tr>
                        <tr>
                            <td>Marital Status</td>
                            <td>{personaldata.Marital_Status}</td>
                        </tr>
                        <tr>
                            <td>Hobbies</td>
                            <td>{personaldata.Hobbies}</td>  
                        </tr>
                       {/*--------------personal details edit button ---------  */}
                        <tr className='editbtnhide'>
                            <td>Edit Personal Details</td>
                            <td><button onClick={()=>{personaldataedit(personaldata)}} style={{padding: "5px 15px", cursor: "pointer", backgroundColor: "rgb(36, 36, 51)", border: "none", color:"white", borderRadius: "4px", fontSize: "20px"}}>Edit</button></td>  
                        </tr>
                    </tbody>
                </table>
                <table className='maintable'>
                    <caption>Address Details</caption>
                    <thead>
                        <tr>
                            <td>House Number</td>
                            <td>{Addressdata.hnum}</td>
                        </tr>
                        <tr>
                            <td>Village</td>
                            <td>{Addressdata.Village}</td>
                        </tr>
                        <tr>
                            <td>Thana</td>
                            <td>{Addressdata.Thana}</td>
                        </tr>
                        <tr>
                            <td>Post Office</td>
                            <td>{Addressdata.Post_Office}</td>
                        </tr>
                        <tr>
                            <td>District</td>
                            <td>{Addressdata.District}</td>
                        </tr>
                        <tr>
                            <td>State</td>
                            <td>{Addressdata.State}</td>
                        </tr>
                        <tr>
                            <td>Pin Code</td>
                            <td>{Addressdata.Pin_Code}</td>
                        </tr>
                        {/* -------------Address edit button---------------- */}
                        <tr>
                            <td>Edit Address Details</td>
                            <td><button onClick={()=>{Addressdataedit(Addressdata)}} style={{padding: "5px 15px", cursor: "pointer", backgroundColor: "rgb(36, 36, 51)", border: "none", color:"white", borderRadius: "4px", fontSize: "20px"}}>Edit</button></td>  
                        </tr>
                    </thead>
                </table>
                <table className='maintable'>
                    <caption>Contact Details</caption>
                    <thead>
                        <tr>
                            <td>Mobile Number</td>
                            <td>{Contactdata.mobnum}</td>
                        </tr>
                        <tr>
                            <td>Email ID</td>
                            <td>{Contactdata.Email_ID}</td> 
                        </tr>
                        <tr>
                            <td>Alternat Mobile</td>
                            <td>{Contactdata.Alternate}</td>
                        </tr>
                           {/*-----------------contact edit button ------------  */}
                        <tr>
                            <td>Edit Contact Details</td>
                            <td><button onClick={()=>{contactdataedit(Contactdata)}} style={{padding: "5px 15px",  cursor: "pointer", backgroundColor: "rgb(36, 36, 51)", border: "none", color:"white", borderRadius: "4px", fontSize: "20px"}}>Edit</button></td>  
                        </tr>
                    </thead>
                </table>

                {/*-------------Academic loop table ---------------------  */}
                <table className='academic_table maintable'>
                    <caption>Academic Qualification</caption>
                    
                    <thead>
                        <tr> 
                            <td>Exam</td>
                            <td>Board/Univercity Name</td>
                            <td>Passing Year</td>
                            <td>%Age</td>
                        </tr>
                    </thead>
                    <tbody>

                        {
                            fdata.map(
                                Dataexam =>(
                                    
                                    <tr>
                                        <td>{Dataexam.ExamName}</td>
                                        <td>{Dataexam.BoardName}</td>
                                        <td>{Dataexam.PassingYear}</td>
                                        <td>{Dataexam.PercentAge}</td>  
                                    </tr>
                                       

                                    
                                )
                                
                            )
                            
                            
                        }
                        
                    </tbody>
                </table>
                <table className='passport_table maintable'> 
                    <caption>Passport Check Details</caption>
                    
                    <thead>
                        <tr>
                            <td>Aadhaar Number</td>
                            <td>Passport Number</td>
                            <td>Issuing Date</td>
                            <td>Expiry Date</td>
                            <td>Issu District</td>
                        </tr>
                    </thead>
                    <tbody>

                       
                                    
                        <tr>
                            <td>{maainfinaldatapassport.AadhaarNum}</td>
                            <td>{maainfinaldatapassport.paassportnumber}</td>
                            <td>{maainfinaldatapassport.passportissuingdate}</td>
                            <td>{maainfinaldatapassport.passportexpirydate}</td>  
                            <td>{maainfinaldatapassport.passportdistrict}</td>
                        </tr>
                                       

                              
                        
                    </tbody>
                </table>
                <table className='Physical_table maintable'>
                    <caption>Physical Details</caption>
                    
                    <thead>
                        <tr>
                            <td>Height</td>
                            <td>Weight</td>
                            <td>Blood Group</td>
                            <td>PwP Disability</td>
                            
                        </tr>
                    </thead>
                    <tbody>

                        
                        <tr>
                            <td>{preview.Height}</td>
                            <td>{preview.weight}</td>
                            <td>{preview.BloodGroup}</td>
                            <td>{preview.Pwpdisability}</td>  
                        </tr>
                                       

                        
                    </tbody>
                </table>
                <table className='comtable maintable'>
                    <caption>Computer Qualification</caption>  
                    <thead>
                        <tr>
                            <td>Course Name</td>
                            <td>From</td>
                            <td>Passing Year</td>
                            <td>percent</td>
                        </tr>
                    </thead>
                    <tbody>
                       {
                        Finalcomdata.map(
                            compval=>(
                                <tr>
                                    <td>{compval.CourseName}</td>
                                    <td>{compval.Frompass}</td>
                                    <td>{compval.Compassingy}</td>
                                    <td>{compval.compercent}</td>
                                </tr>

                                
                            )
                        )
                       }
                    </tbody>
                </table>
                <table className='tech_table maintable'>
                    <caption>Technical Qualification</caption>
                    <thead>
                        <tr>
                            <td>Course Name</td>
                            <td>Trade</td>
                            <td>Passing Year</td>
                            <td>percent</td>
                        </tr>
                    </thead>
                    
                        {
                            FinalTechData.map(
                                techdatafun =>(
                                    <tbody>
                                        <tr>
                                            <td>{techdatafun.TechCourseName}</td>
                                            <td>{techdatafun.TechTradeName}</td>
                                            <td>{techdatafun.TechPassingYear}</td>
                                            <td>{techdatafun.TechPercentage}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="4">{techdatafun.Techfromwhere}</td>
                                        </tr>
                                    </tbody>


                                )
                            )
                        }
                </table>
                <table className='exptab tech_table maintable'>
                    <caption>Experiance Section</caption>
                    <thead>
                        <tr>
                            <td>Experiance Year</td>
                            <td>Working As</td>
                            <td>Company Name & Address</td>
                            <td>Period</td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            Finalexperiancedata.map(
                                expdatamap =>(
                                    <tr>
                                        <td>{expdatamap.ExperianceYear}</td>
                                        <td>{expdatamap.CompanyName}</td>
                                        <td>{expdatamap.CompanyAddress}</td>
                                        <td>{expdatamap.FromDateToDate}</td>
                                    </tr>
                                )
                            )
                        }
                        
                    </tbody>      
                </table>
                <div>
                <p style={{border:"1px solid black", padding:"15px", fontWeight:"bold", margin:"0"}}>Carrier Objective:- <span style={{fontWeight:"normal", fontSize:"normal"}}>{checkbox}</span></p>

                </div>
                <div className='btn_cont'>
                    <button onClick={submitbtnhandler} className='submit_btn'><Link className='submit_btn_link' to='../ChooseDes'>Submit</Link></button>
                </div>
            </div>
            
        </div>
    );
}

export default Registrationdetails;   